module.exports = __webpack_public_path__ + "media/gastric dysplasia.79eda3b0.wav";